import { render, staticRenderFns } from "./right_box.vue?vue&type=template&id=36dc50a2&"
import script from "./right_box.vue?vue&type=script&lang=js&"
export * from "./right_box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports